const API_URL = process.env.REACT_APP_API_URL;

// POST /clef — crée une clé API et retourne la clé générée (une seule fois)
export async function createClef(data) {
  const response = await fetch(`${API_URL}/clef/`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      api: {
        clef: data.clef,
        module: data.module,
        permissions: data.permissions,
        expiration: data.expiration,
      },
    }),
  });

  if (!response.ok) {
    throw new Error("Erreur lors de la création de la clé API");
  }

  const body = await response.json();
  // Retourne directement la clé générée (data.key)
  return body?.data?.key;
}

// GET /clef — récupère les clés API existantes (sans la clé en clair)
export async function getClefs() {
  const response = await fetch(`${API_URL}/clef/`, {
    method: "GET",
    credentials: "include",
  });

  if (!response.ok) {
    throw new Error("Erreur lors de la récupération des clés API");
  }

  return response.json();
}
